export default "__VITE_ASSET__bf4d7bbb__"